import StoryModule from '../components/StoryModule';

const OriginCut = () => <StoryModule slug="origin-cut" />;

export default OriginCut;
